export function createMessage() {
  switch (arguments[0]) {
    case 'auth':
      return JSON.stringify({
        service: 'auth',
        data: { session_id: arguments[1], login_params: 'param' },
      })
    case 'settings':
      return JSON.stringify({ service: 'settings', data: arguments[1] })
    case 'pf':
      return JSON.stringify({ service: 'pf', data: arguments[1] })
    case 'bet':
      return JSON.stringify({
        service: 'bet',
        data: { amount: arguments[1], boundary: +arguments[2], over_or_under: arguments[3] }
      })
    case 'bet_reply':
      return JSON.stringify({
        service: 'bet_reply',
        data: { amount: arguments[2], round_id: arguments[1] },
      })
    default:
      break
  }
  return
}
